/** Routes (production plan §12.1). */
import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "./auth/AuthContext";
import { AppShell } from "./components/AppShell";
import { Spinner } from "./components/ui";
import { AdminOrgsPage } from "./pages/AdminOrgs";
import { AuthActionPage } from "./pages/AuthAction";
import { EvidencePage } from "./pages/Evidence";
import { LoginPage } from "./pages/Login";
import { MembersPage } from "./pages/Members";
import { NewProjectPage } from "./pages/NewProject";
import { PortfolioPage } from "./pages/Portfolio";
import { ProgrammePage } from "./pages/Programme";
import { ProjectSettingsPage } from "./pages/ProjectSettings";
import { RunPage } from "./pages/Run";
import { SetupPage } from "./pages/Setup";

function RequireAuth() {
  const { ready, user, error } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="auth-page">
        <Spinner label="Starting" />
      </div>
    );
  }
  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">The application could not start: {error}</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/action", element: <AuthActionPage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: "/", element: <PortfolioPage /> },
      { path: "/new", element: <NewProjectPage /> },
      { path: "/p/:pid", element: <ProgrammePage /> },
      { path: "/p/:pid/evidence", element: <EvidencePage /> },
      { path: "/p/:pid/batches/:bid/setup", element: <SetupPage /> },
      { path: "/p/:pid/runs/:rid", element: <RunPage /> },
      { path: "/p/:pid/settings", element: <ProjectSettingsPage /> },
      { path: "/org/members", element: <MembersPage /> },
      { path: "/admin/orgs", element: <AdminOrgsPage /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
